import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Input } from 'antd';

import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';

export class InputComponent extends Component {
    static propTypes = {
        className: PropTypes.string,
        input: PropTypes.object.isRequired,
        onChange: PropTypes.func,
        meta: PropTypes.object.isRequired,
        type: PropTypes.string,
        visibilityToggle: PropTypes.bool,
        placeholder: PropTypes.string
    };

    getInputClasses(className, { invalid, submitFailed }) {
        return cx(`${className} input form-control`, { error: invalid && submitFailed });
    }

    render() {
        const { className, meta, input, onChange, visibilityToggle, ...rest } = this.props;
        const classes = this.getInputClasses(className, meta);

        return (
            <div className={cx({'fg-line': !className})}>
                { (rest.type || input.type) === 'search'
                    ? <Input.Search onSearch={value => onChange(value)} {...rest} defaultValue={input.value} className={classes} />
                    : (rest.type || input.type) === 'password'
                        ? <Input.Password {...input} {...rest} className={classes} visibilityToggle={visibilityToggle} />
                        : <Input {...input} {...rest} className={classes} />
                }
            </div>
        );
    }
}

export default withTranslatePlaceholder(withFieldWrapper(InputComponent));
export const GuestInputComponent = withTranslatePlaceholder(InputComponent);
